<template lang="pug">
div.ag-custom-cell.ag-cell-list
  .trigger(@click='showDetails' v-tooltip.top='tooltip' ref='optionWrapper')
  div.ag-custom-cell-value
    span.option-text(ref='optionLabel') {{val}}
    span.description(v-if='empty && showCaret') Select {{placeholder}}
  | &nbsp;&nbsp;
  i.fas.fa-caret-down.ag-row-expand-icon.pull-right(
    v-if='showCaret'
    xv-tooltip.bottom='"Show more options"'
    @click='showDetails'
  )
  div.ag-row-details.ag-menu.fade(:style='position', :class='{ "shown": shownDetails }')
    i.ag-row-expand-close.fal.fa-times(@click='showDetails')
    div.ag-row-details-content.ag-filter
      list(v-if='shownDetails' :init='params' @click='edit' ref='list')
</template>

<script>

import List from '../filters/list'

export default {
  components: {
    List
  },

  data() {
    return {
      shownDetails: false,
      loadedDetails: false,
      details: '',
      tooltip: ''
    }
  },

  computed: {
    position() {
      return {
        // 'min-width': '93%',
        // width: this.cell.style.width
      }
    },
    showCaret() {
      let editable = this.params.colDef.columnEditable
      return !(this.params.data || {})._disabled && this.val && editable
    },
    placeholder() {
      return this.params.colDef.headerName
    },
    empty() {
      return !this.params.value && this.params.node.rowPinned !== 'bottom'
    }
  },

  created() {
    //
    this.colApi = this.params.api && this.params.api.columnController

    this.cell = this.params.eGridCell
    this.cell.style.overflow = 'visible'

    this.params.editMode = true
    this.cell.className = this.cell.className.replace(' ag-cell-list-expanded', '') + ' ag-cell-list-expanded'
    this.val = this.params.formatValue(this.params.value)
  },

  mounted() {
    this.$nextTick(() => {
      const textW = this.$refs.optionLabel && this.$refs.optionLabel.getBoundingClientRect().width
      const wrapperW = this.$refs.optionWrapper && this.$refs.optionWrapper.clientWidth - 35
      if (textW && wrapperW) {
        this.tooltip = textW > wrapperW
          ? this.val
          : null
      }
    })
  },

  methods: {
    showDetails(e) {
      if (!this.showCaret) return

      this.shownDetails = !this.shownDetails
      this.params.context.shownPopover = this.shownDetails

      this.getSelected()

      this.$nextTick(() => {
        this.$refs.list && this.$refs.list.$emit('showDetails', this.shownDetails)
      })
    },

    getSelected() {
      if (this.params.colDef.options && this.shownDetails) {
        this.params.colDef.options.map(key => {
          key.status = key.label === this.params.value
          key.isDisabled = this.params.colDef.selectedOptions && this.params.colDef.selectedOptions.filter(o => +o[this.params.colDef.trackBy.selectedOptionTrackBy] === +key[this.params.colDef.trackBy.optionTrackBy]).length > 0
        })
      }
    },

    edit(v) {
      this.params.setValue(v.text || v.label || v.name || '')
      this.params.value = v.label
      this.val = this.params.formatValue(this.params.value)

      this.params.context.data && this.params.context.gridOptions.api.refreshInfiniteCache()
    },

    refresh() {
      //
      this.shownDetails = false
    }
  }
}

</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

.ag-custom-cell.ag-cell-list {
  .option-text {
    display: inline-block;
  }
}

.ag-body-container .ag-cell.ag-cell-list-expanded {
  display: inline-block;
  width: 100%;

  &:hover {
    .ag-row-expand-icon {
      @include theme {
        color: v(ink);
      }
    }
  }
}
.ag-body-container .ag-cell:not(.disabled) .ag-custom-cell {
  display: inline-block;
  &.ag-cell-list {
    min-width: 85%;
    //top: -2px;
    position: relative;
    padding: 0 5px;

    width: 100%;

    @include theme {
      //border: 1px solid v(background);
    }

    &:hover {
      cursor: pointer;
      @include theme {
        //border: 1px solid v(tertiary-01);
      }
    }

    .trigger {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  input.form-control[search] {
    //width: 90%;
  }

  .list.edit {
    margin: 0;

    .form-group {
      margin: 0;
    }

    input[type="checkbox"], .check-mask {
      display: none;
    }
  }
}

.ag-body-container .ag-row.disabled .ag-custom-cell {
  border: none;
}

.ag-custom-cell-value {
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80%;
}

.ag-cell-list .ag-row-expand-icon {
  font-size: $font-size-large;
  vertical-align: middle;
  cursor: pointer;
  @include theme {
  color: v(border);
  }
  //right: 14px;
  margin-right: -4px;
  margin-top: 2px;

  /* &:after {
    content: '';
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: inherit;
    opacity: 0.8;
    position: absolute;
    margin-left: -17px;
    margin-top: -6px;
    z-index: -1;
    transition: 0.2s all ease-in-out;
  } */

  &:hover {
    @include theme {
    color: v(ink);
    }

    &:after {
      @include theme {
      background: v(background-lightest);
      }
    }
  }
}
.ag-row-expand-close {
  font-size: $font-size-base-lg;
  vertical-align: middle;
  cursor: pointer;
  @include theme {
  color: v(ink);
  }
  position: absolute;
  left: -10px;

  .ag-cell-list & {
    //display: none;
    left: auto;
    right: 10px;
    top: 6px;
    z-index: 999;
  }
}

.ag-row-details {
  background: #fff;
  @include theme {
  border-bottom: 1px solid v(background);
  }
  position: absolute;
  top: 30px;
  left: auto;
  width: auto;
  height: 90px;
  margin: -1px;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: -1;
  padding: 20px 30px;

  .ag-cell-list & {
    left: 0;
    padding: 0;
    height: auto;
  }

  .ag-row-details-content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .content.grid .ag-fresh &.ag-menu {
    @include theme {
    border-color: v(background-light);
    }
    border-top: none;
    //margin-top: -31px;
    margin-left: -2px;
    z-index: -1;
    width: calc(100% + 8px);
    min-width: 150px;
  }
  .content.grid .ag-fresh &.ag-menu.shown,
  .content.grid .ag-fresh &.ag-menu.shown .ag-filter {
    opacity: 1;
    z-index: 999;
    padding: 0;
    box-shadow: $box-shadow;
  }
  .content.grid .ag-fresh &.ag-menu.shown .ag-filter {
    margin-top: -1px;
    margin-left: -10px;
  }
}

.ag-row-expanded {
  /*@include theme {
  background: lighten(v(secondary-04), 8%);
  }*/
}
//.theme .ag-cell-expanded,
.ag-cell-focus.ag-cell-list-expanded {
  border-color: transparent;
  @include theme {
  border-right-color: v(background-light);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Grid/cells/list.vue